module.exports = __webpack_public_path__ + "img/me.7205477b.svg";